import { render, staticRenderFns } from "./NewFormOfPaymentForm.vue?vue&type=template&id=8612e212&scoped=true"
import script from "./NewFormOfPaymentForm.vue?vue&type=script&lang=js"
export * from "./NewFormOfPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8612e212",
  null
  
)

export default component.exports